import classNames from "classnames";
import * as mobx from "mobx";
import React from "react";
import { createPortal } from "react-dom";
import { atom, deepAtom } from "../atom";
import { initialSearchParamEntriesBox } from "./CanvasState";
import { ParentComlinkAPI } from "./FrameSandboxAPI";
import { CANVAS_PORTAL_ID } from "./SandboxConstants";

function CanvasPortal({
  children,
  x,
  y,
  z,
  className,
}: {
  children: React.ReactNode;
  x?: number;
  y?: number;
  z?: number;
  className?: string;
}) {
  return createPortal(
    <div
      className={classNames("absolute select-auto", className)}
      style={{
        left: `${x ?? 0}px`,
        top: `${y ?? 0}px`,
        zIndex: z ?? undefined,
      }}
    >
      {children}
    </div>,
    document.getElementById(CANVAS_PORTAL_ID)!
  );
}

export const NattoLibrary = {
  getURLSearchParams: () => initialSearchParamEntriesBox.get(),
  CanvasPortal,
  experimental: {
    openFileDirectory: ParentComlinkAPI.openFileDirectory,
    atom,
    deepAtom,
    mobx,
  },
};
